import styled from 'styled-components'

export const HeaderContainer = styled.header`

`